import type { LngLat } from "@maptiler/sdk";
import type { Tile } from "../../types/tiles";

function getTileForCoordinates(geographicCoordinates: LngLat, zoom: number): Tile {
  const numberOfTiles = 2 ** zoom;

  const { lat, lng } = geographicCoordinates;

  const latRad = (lat * Math.PI) / 180;

  let x = ((lng + 180) / 360) * numberOfTiles;
  let y = ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * numberOfTiles;

  x = Math.floor(((x % numberOfTiles) + numberOfTiles) % numberOfTiles);
  y = Math.floor(Math.max(0, Math.min(y, numberOfTiles - 1)));

  return {
    id: `${zoom}/${x}/${y}`,
    x,
    y,
    z: zoom,
  };
}

export { getTileForCoordinates };
